<template>
	<page>
		<module>
			<view-list work-type="29" ref="view" selector :view-config="auth('b_out_sourcing_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="单据编号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="工序">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item label="供应商">
							<c-select name="supplier_ids" async multiple @search="searchSupplier" ></c-select>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_out_sourcing_export')" v-lock="lock('b_out_sourcing_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_out_sourcing_export')" v-lock="lock('b_out_sourcing_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_out_sourcing_export')" v-lock="lock('b_out_sourcing_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_out_sourcing_export')" v-lock="lock('b_out_sourcing_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_out_sourcing_print')" v-lock="lock('b_out_sourcing_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>
				
				<!--委外单编号-->
				<template #order_code="{data}">
					<c-link @click="globalDialog('outSourcingDetail', {props: {id: data.id}})">{{data.order_code}}</c-link>
				</template>
				
				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>

				<!--关联单据-->
				<template #process_name="{data}">
					<order-link type="task" :id="data.ref_id" :code="data.process_name"></order-link>
				</template>

				<!--单据状态-->
				<template #state="{data}">
					<c-state dict="orderStateDic" tag :value="data.state"></c-state>
				</template>

				<!--优先级-->
				<template #priority="{data}">
					<c-state dict="priorityDic" tag :value="data.priority"></c-state>
				</template>
				
				<!--单价-->
				<template #price="{data}">
					￥{{parseFloat(parseFloat(data.price).toFixed(6))}}
				</template>
				
				<!--金额-->
				<template #money="{data}">
					￥{{parseFloat(data.money).toFixed(2)}}
				</template>
				
				<!--结算金额-->
				<template #settled_money="{data}">
					￥{{parseFloat(data.settled_money).toFixed(2)}}
				</template>

				<!--生产进度%-->
				<template #progress="{data}">
					<c-progress :rate="[data.receive_count, data.plan_count]" :color="((data.receive_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="globalDialog('outSourcingDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_outsourcing_order_receive')" v-lock="lock('b_outsourcing_order_receive')" icon="tf-take-goods" @click="receiveOrSendOrder(data,2)">收货</c-table-button>
						<c-table-button v-if="auth('b_out_sourcing_print')" v-lock="lock('b_out_sourcing_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_outsourcing_order_send')" v-lock="lock('b_outsourcing_order_send')" icon="tf-deliver" @click="receiveOrSendOrder(data,1)">发货</c-table-button>
						<c-table-button v-if="auth('b_outsourcing_order_progress')" v-lock="lock('b_outsourcing_order_progress')" icon="tf-record" @click="orderProgress(data)">动态</c-table-button>
                        <c-table-button v-if="auth('b_outsourcing_settle_add')" v-lock="lock('b_outsourcing_settle_add')" icon="tf-settle-account" @click="settleOrder(data)">结算</c-table-button>
                        <!--<c-table-button v-if="auth('b_outsourcing_order_share')" v-lock="lock('b_outsourcing_order_share')" @click="shareOrder(data)">分享</c-table-button>-->
						<c-table-button v-if="auth('b_outsourcing_order_edit')" v-lock="lock('b_outsourcing_order_edit')" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_outsourcing_order_remove')" v-lock="lock('b_outsourcing_order_remove')" icon="tf-trash" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--委外单收货、发货、增加动态弹窗-->
			<out-sourcing-process-edit ref="outSourcingProcessEdit" @resolve="$refs.view.update()"></out-sourcing-process-edit>
			<!--委外单动态信息列表弹窗-->
			<out-sourcing-process ref="outSourcingProcess"></out-sourcing-process>
            <!--委外结算单编辑动态弹窗-->
            <out-sourcing-settle-edit ref="outSourcingSettleEdit"></out-sourcing-settle-edit>
			<!--委外单编辑弹窗-->
			<out-sourcing-edit ref="outSourcingEdit" @resolve="$refs.view.update()"></out-sourcing-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import outSourcingProcessEdit from "@/pages/supply/out_sourcing_order_process_edit.vue";
	import outSourcingProcess from "@/pages/supply/out_sourcing_order_process_list.vue";
	import outSourcingSettleEdit from "@/pages/supply/out_sourcing_order_settle_edit.vue";
	import outSourcingEdit from "@/pages/supply/out_sourcing_order_edit.vue";

	export default {
		components: {
			outSourcingProcessEdit,outSourcingProcess,outSourcingSettleEdit,outSourcingEdit
		},
		
		data() {
			return {
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateDic','priorityDic']),
		},
		
		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/*******搜索【供应商】下拉框信息*****************/
			searchSupplier(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SUPPLIER',
						keyword: keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/**
			 * 发货 、收货
			 * @param data      外协单信息
			 * @param type      类型 1：发货  2：收货
			 */
			receiveOrSendOrder(data,type){
				data.processInfo = null;
				this.$refs.outSourcingProcessEdit.open(data,type);
			},
			/**
			 * 查询委外单的动态信息
			 */
			orderProgress(data){
				this.$refs.outSourcingProcess.open(data);
			},
			/**
			 * 添加委外结算单
			 */
            settleOrder(data){
                //可结算金额 = 单价*已回数
                var money1 = (parseFloat(data.receive_count) * parseFloat(data.price)).toFixed(2);
                var money2 = parseFloat(data.settled_money).toFixed(2);
				this.$refs.outSourcingSettleEdit.open({
                    out_sourcing_order_id:data.id,
                    outsourcing_code:data.order_code,
                    work_code:data.work_code,
                    can_settle_money: money2 +' / '+money1
                });
			},
			/**
			 * 编辑委外单
			 */
			editOrder(data){
				this.$refs.outSourcingEdit.edit(data);
			},

			/******删除委外单************/
			removeOrder(data){/**/
				this.$confirm({
					message:'确认删除当前委外单【'+data.order_code+'】？删除后不可恢复',  // 提示内容,
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url:'/out/sourcing/order/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>